export function safeSource(url: string) {
  try {
    const u = new URL(url);
    return ['https:', 'http:'].includes(u.protocol) && !u.username && !u.password;
  } catch {
    return false;
  }
}
